import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZonelessChangeDetection, LOCALE_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// Factory to provide the current locale for Angular pipes
function localeIdFactory() {
  const translate = inject(TranslateService);

  return translate.getCurrentLang() || translate.getFallbackLang() || 'en';
}
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { appRoutes } from './app.routes';
import { appConfig as envConfig } from 'environments/environment';

import { AppInitializerService, apiInterceptor } from './app-services';
import { PwaService } from './app-services/pwa.service';
import { TranslatedDatepickerIntl, TranslatedPaginatorIntl } from './app-services/translated-material-intl.service';

export const applicationConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideNativeDateAdapter(),
    { provide: MatDatepickerIntl, useClass: TranslatedDatepickerIntl },
    { provide: MatPaginatorIntl, useClass: TranslatedPaginatorIntl },
    provideHttpClient(withFetch(), withInterceptors([apiInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: provideTranslateHttpLoader({
          prefix: 'assets/i18n/',
          suffix: '.json',
          enforceLoading: true,
          useHttpBackend: true,
        }),
      }),
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: envConfig.production,
    }),
    { provide: LOCALE_ID, useFactory: localeIdFactory },
    provideAppInitializer(() => inject(PwaService).initPwaPrompt()),
    provideAppInitializer(() => inject(AppInitializerService).load()),
  ],
};
